function opdaterNedtaelling() {

  const nedtaellingElement = document.getElementById('nedtaelling');  
  const fristTider = nedtaellingElement.getAttribute('data-frist').split(';');

  const lukkedeDatoerData = nedtaellingElement.getAttribute('data-lukkede-datoer');
  const lukkedeDatoer = lukkedeDatoerData.split(';').map(dato => new Date(dato.split('-')[2], dato.split('-')[1] - 1, dato.split('-')[0]));

  const nu = new Date();
  const ugedag = nu.getDay();
  const fristTid = fristTider[ugedag];

  // Tjek om den nuværende dato er en lukket dato
  const erLukketDato = lukkedeDatoer.some(lukketDato => {
    return lukketDato.getFullYear() === nu.getFullYear() &&
      lukketDato.getMonth() === nu.getMonth() &&
      lukketDato.getDate() === nu.getDate();
  });

  if (erLukketDato || !fristTid) {
    nedtaellingElement.style.display = 'none';
    return;
  }

  const [fristTimer, fristMinutter] = fristTid.split(':');

  const nuDatoStreng = nu.toISOString().slice(0, 10);
  
  if (!lukkedeDatoer.includes(nuDatoStreng)) {
    const frist = new Date(nu.getFullYear(), nu.getMonth(), nu.getDate(), fristTimer, fristMinutter, 0);
    const tidsforskel = frist - nu;
    const hoursBeforeShowingCountdown = parseInt(nedtaellingElement.getAttribute('data-hours-before-showing-countdown'));
  
    if (tidsforskel > 0 && tidsforskel <= hoursBeforeShowingCountdown * 60 * 60 * 1000) {
      const timer = Math.floor((tidsforskel % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutter = Math.floor((tidsforskel % (1000 * 60 * 60)) / (1000 * 60));
      const sekunder = Math.floor((tidsforskel % (1000 * 60)) / 1000);

      // Nicolai 7/9-2026: timer skjules helt, når der er under en time tilbage ("42 m 50 s" i stedet for "0 t 42 m 50 s").
      const to = (n) => (n < 10 ? '0' + n : '' + n);
      const timerFelt = document.getElementById('timer');
      const timerEnhed = timerFelt.nextElementSibling;
      if (timer > 0) {
        timerFelt.innerHTML = timer;
        timerFelt.hidden = false;
        if (timerEnhed) timerEnhed.hidden = false;
        document.getElementById('minutter').innerHTML = to(minutter);
      } else {
        timerFelt.innerHTML = '';
        timerFelt.hidden = true;
        if (timerEnhed) timerEnhed.hidden = true;
        document.getElementById('minutter').innerHTML = minutter;
      }
      document.getElementById('sekunder').innerHTML = to(sekunder);
      updateTimeBold();

      document.getElementById('nedtaelling').style.display = 'block';
    } else {
      document.getElementById('nedtaelling').style.display = 'none';
    }
  } else {
    document.getElementById('nedtaelling').style.display = 'none';
  }
}

function updateTimeBold() {
  const nedtaellingElement = document.getElementById('nedtaelling');
  const timeBoldSetting = nedtaellingElement.getAttribute('data-time-bold');

  const nedtaellingPElement = document.querySelector("#nedtaelling p")
  const timeColorSetting = nedtaellingElement.getAttribute('data-text-color');
  nedtaellingPElement.style.color = timeColorSetting;
  
  if (timeBoldSetting === 'true') {
    
      document.querySelector('#nedtaelling #nedtaelling-tid').style.fontWeight = 'bold';
    
  }
}

document.addEventListener('DOMContentLoaded', function() {
  opdaterNedtaelling();
  setInterval(opdaterNedtaelling, 1000);
});